import { h } from 'preact';
import { useState, useRef, useCallback, useEffect } from 'preact/hooks';
import { debounce } from '../debounce';

export function TextAreaEntry({
  id,
  label,
  value,
  onChange,
  rows = 3,
  disabled = false,
  validate,
  description,
  placeholder,
  debounce: debounceOpt = false,
}) {
  const [error, setError] = useState(null);
  const debouncedRef = useRef(null);

  const handleChange = useCallback(
    (val) => {
      if (validate) {
        const err = validate(val);
        setError(err || null);
        if (err) return;
      }
      onChange(val);
    },
    [onChange, validate],
  );

  useEffect(() => {
    if (debounceOpt) {
      const delay = typeof debounceOpt === 'number' ? debounceOpt : 300;
      debouncedRef.current = debounce(handleChange, delay);
      return () => debouncedRef.current.cancel();
    }
    debouncedRef.current = null;
  }, [debounceOpt, handleChange]);

  const onInput = (e) => {
    const val = e.target.value;
    if (validate) {
      setError(validate(val) || null);
    }
    if (debouncedRef.current) {
      debouncedRef.current(val);
    } else {
      handleChange(val);
    }
  };

  return (
    <div class={`epx-entry epx-textarea${error ? ' has-error' : ''}`}>
      <label class="epx-entry-label" htmlFor={id}>{label}</label>
      <textarea
        id={id}
        class="epx-entry-input epx-entry-textarea"
        rows={rows}
        placeholder={placeholder || ''}
        disabled={disabled}
        onInput={onInput}
      >{value || ''}</textarea>
      {error && <div class="epx-entry-error">{error}</div>}
      {description && <div class="epx-entry-description">{description}</div>}
    </div>
  );
}
